import { getMobileOS } from './detect-mobile';

/** Only one animation may be running at a time, thus animationFrame is global variable */
import { getNodeScrollOffset } from './dom-helpers';

/** if scroll is animated, it can be prevented by user scroll */
let isAnimatedScroll = false;
let startTs = null;
let duration = null;
let animationFrame = null;
let initialTop = null;

const isMobileOS = !!getMobileOS();
const userEvent = isMobileOS ? 'touchstart' : 'scroll';
let data = [];

/**
 * If another scroll is fired or user fires manual scroll, animation quits execution
 */
const endAnimation = (e) => {
  // console.log('endAnimation');
  data = [...data, { isAnimatedScroll, eventNotNull: !!e }];
  /** ignore scroll events if they triggered by scrollTo */
  if (e && isAnimatedScroll) {
    isAnimatedScroll = false;
  } else {
    // alert(`quit scroll ${JSON.stringify(data)}`);
    cancelAnimationFrame(animationFrame);
    animationFrame = null;
    window.removeEventListener(userEvent, endAnimation);
  }
};

/**
 * Wrapper for window.scrollTo that marks event as animated
 * animated events are automatically cancelled if user fires manual scroll
 */
export const scrollTo = (top) => {
  /**
   * this will tell that next scroll event is not user triggered
   */
  if (!isMobileOS) isAnimatedScroll = true;
  window.scrollTo(0, top);
};

// const easeOutQuad = t => t * (2 - t);
const easeOutQuart = t => t < .5 ? 8 * t * t * t * t : 1 - 8 * (--t) * t * t * t; // eslint-disable-line

/**
 * Function used to scroll to node
 * @param node - dom node to scroll to
 * @param callback - optional, fired after scroll is done
 * @param finalOffset - optional, allows to define pixel offset from node to finish scroll at
 */
export const scrollAnimate = (node, callback, finalOffset = 0) => {
  console.assert(!!node, 'Attempting to scroll to non existing block');
  isAnimatedScroll = false;
  endAnimation();
  let pageTop = window.pageYOffset;
  let now = 0;

  /** duration should vary by distance, with a min and max */
  duration = node.getBoundingClientRect().top + finalOffset - pageTop;
  duration = Math.max(Math.min(Math.abs(duration), 2000), 800);
  initialTop = window.pageYOffset;
  startTs = window.performance.now();

  const scrollFrame = () =>
    requestAnimationFrame(() => {
      const currentTs = window.performance.now();
      const currentTop = window.pageYOffset;

      // node doesn't exist anymore
      if (!node) {
        endAnimation();
        return;
      }

      /** targetTop represents offset from top of screen to the node with finalOffset */
      const targetTop = node.getBoundingClientRect().top + currentTop + finalOffset;

      /**
       * Apply initial offset correction based on value of current scroll
       */
      initialTop = (currentTop - targetTop * now) / (1 - now);

      now = easeOutQuart(Math.min((currentTs - startTs) / duration, 1));

      pageTop = initialTop + (targetTop - initialTop) * now;

      // reverse:
      // initialTop = (currentTop - targetTop * now) / (1 - now);

      // we scroll to absolute positioned node
      if (Math.abs(targetTop) >= document.body.clientHeight) {
        endAnimation();
        return;
      }

      scrollTo(pageTop);
      if (now < 1) {
        animationFrame = scrollFrame();
      }
      /**
       * one of the following is true
       * scrolling down and near target
       * scrolling down and near bottom of the screen
       * scrolling up and near target
       */
      // if (
      //   isScrollDown && targetTop <= pageTop ||
      //   isScrollDown && (document.body.clientHeight - window.innerHeight) - pageTop <= 0 ||
      //   !isScrollDown && targetTop >= pageTop
      // ) {
      //   /** last step of scroll */
      //   scrollTo(targetTop);
      //   endAnimation();
      //   if (callback) callback();
      // } else {
      /** just an another step of scroll */
      // };

      // return true;
      // }, 16.6);
    });

  scrollFrame();
  window.addEventListener(userEvent, endAnimation);
};

export const scrollAnimateIfNeeded = (node, ...args) => {
  console.assert(!!node, 'Attempting to scroll to non existing block');
  if (getNodeScrollOffset(node) < 0 || getNodeScrollOffset(node, true) < 0) {
    scrollAnimate(node, ...args);
  }
};

export const scrollById = (id, finalOffset = 0) => {
  const node = document.getElementById(id);
  scrollAnimate(node, null, finalOffset);
};
